export const SET_CURRENT_PLAN_ID = "SET_CURRENT_PLAN_ID";

export const CHANGE_CURSOR_POS = "CHANGE_CURSOR_POS";

export const CLEAR_STATE = "CLEAR_STATE";

export const WEBSOCKET_CONNECTION = "WEBSOCKET_CONNECTION";
export const WEBSOCKET_CONNECTION_SUCCESS = "WEBSOCKET_CONNECTION_SUCCESS";
export const WEBSOCKET_CONNECTION_ERROR = "WEBSOCKET_CONNECTION_ERROR";

export const MQTT_CONNECTION = "MQTT_CONNECTION";
export const MQTT_CONNECTION_SUCCESS = "MQTT_CONNECTION_SUCCESS";
export const MQTT_CONNECTION_ERROR = "MQTT_CONNECTION_ERROR";
